import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import Image from '@nerdwallet/react-image';

const PressLogoTile = ({
  company,
  image,
  height,
  isAwardLogo,
  centered,
  width,
  wideTile,
  midSizeTile,
  smallSizeTile,
  naturalHeight,
  naturalWidth,
  customTileStyle,
}) => {
  const dimensionsStyle = {
    maxHeight: `${height}`,
    maxWidth: `${width}`,
    margin: '0 auto',
  };

  return isAwardLogo ? (
    <div
      className={classNames([
        'logo-nav__tile-awards',
        {
          'logo-nav__tile--wide': wideTile,
          'logo-nav__tile--mid': midSizeTile,
          'logo-nav__tile--small': smallSizeTile,
          'logo-nav__tile--center': centered,
        },
        customTileStyle,
      ])}
    >
      <Image
        src={image}
        alt={company}
        backgroundColor="transparent"
        className={classNames([
          classes(['padding-horizontal-1', 'padding-vertical-1']),
        ])}
        naturalHeight={naturalHeight}
        naturalWidth={naturalWidth}
        style={dimensionsStyle}
        lazy
      />
    </div>
  ) : (
    <div
      className={classNames([
        'logo-nav__tile',
        {
          'logo-nav__tile--wide': wideTile,
          'logo-nav__tile--mid': midSizeTile,
          'logo-nav__tile--small': smallSizeTile,
          'logo-nav__tile--center': centered,
        },
        customTileStyle,
      ])}
    >
      <Image
        src={image}
        alt={company}
        backgroundColor="transparent"
        className={classNames([
          classes(['padding-horizontal-4', 'padding-vertical-4']),
        ])}
        imageClassName="logo-nav__image"
        naturalHeight={naturalHeight}
        naturalWidth={naturalWidth}
        style={dimensionsStyle}
        lazy
      />
    </div>
  );
};

PressLogoTile.propTypes = {
  company: PropTypes.string,
  image: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  wideTile: PropTypes.bool,
  centered: PropTypes.bool,
  naturalHeight: PropTypes.number,
  naturalWidth: PropTypes.number,
  isAwardLogo: PropTypes.bool,
  customTileStyle: PropTypes.string,
  midSizeTile: PropTypes.bool,
  smallSizeTile: PropTypes.bool,
};

PressLogoTile.displayName = 'PressLogoTile';

export default PressLogoTile;
